/* src/app/common/components/notification/notification.component.scss */
ion-card.notification-popup {
  max-height: 400px;
  border-radius: 8px;
  overflow: auto;
}
ion-card.notification-popup ion-title {
  padding: 10px;
  color: #0089ff;
  font-weight: 600;
}
ion-card.notification-popup .notify-text {
  font-size: 15px;
  color: #010010;
  font-weight: 500;
}
ion-card.notification-popup .highlight {
  color: #0e0f10;
  font-weight: 700;
}
/*# sourceMappingURL=notification.component.css.map */
